import { Route } from '../../types';
import { matchRoutes } from '../matchRoutes';
import { preloadMatchedRoutes } from '../preloadMatchedRoutes';

export const preloadRoutes = (routes: Route[], path: string, search: string) =>
  preloadMatchedRoutes(matchRoutes(routes, path), search);
